module.exports = __webpack_public_path__ + "img/energy.560cd9b4.svg";